import {useCallback, useEffect, useState} from 'react'

export default function useJobOffers(apiKey) {
  const [jobRecordCount, setJobRecordCount] = useState(null)
  const [error, setError] = useState(null)
  const [isLoading, setIsLoading] = useState(false)

  const jobRequestOptions = useCallback(
    key => ({
      method: 'GET',
      headers: {
        Authorization: `Token token=${key}`,
        'X-Api-Version': '20210218',
        'Content-Type': 'application/json',
      },
    }),
    [],
  )

  const fetchData = useCallback(async () => {
    if (!apiKey) {
      setError('Missing API key')

      return
    }

    setIsLoading(true)
    setError(null)

    try {
      const requestUrl = 'https://api.teamtailor.com/v1/'
      const jobOffersEndpoint = 'jobs'
      const response = await fetch(
        `${requestUrl}${jobOffersEndpoint}`,
        jobRequestOptions(apiKey),
      )

      if (!response.ok) {
        throw new Error(`Error: ${response.status}, ${response.statusText}`)
      }

      const data = await response.json()

      if (data && data.meta && data.meta['record-count'] !== undefined) {
        setJobRecordCount(data.meta['record-count'])
      } else {
        throw new Error('Invalid data structure received')
      }
    } catch (err) {
      setError(`Error: ${err.message}`)
    } finally {
      setIsLoading(false)
    }
  }, [apiKey, jobRequestOptions])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  return {jobRecordCount, error, isLoading}
}
